export const FLAG_GETTING_MANUAL_VOUCHER_PAYMENTS =
  'FLAG_GETTING_MANUAL_VOUCHER_PAYMENTS';

export const GET_MANUAL_VOUCHER_PAYMENTS = 'GET_MANUAL_VOUCHER_PAYMENTS';

export const CLEAR_MANUAL_VOUCHER_PAYMENTS = 'CLEAR_MANUAL_VOUCHER_PAYMENTS';

export const FLAG_MANUAL_VOUCHER_PAYMENT_ACTIVITY =
  'FLAG_MANUAL_VOUCHER_PAYMENT_ACTIVITY';

export const GET_MANUAL_VOUCHER_PAYMENT = 'GET_MANUAL_VOUCHER_PAYMENT';

export const CLEAR_MANUAL_VOUCHER_PAYMENT = 'CLEAR_MANUAL_VOUCHER_PAYMENT';

export const GET_MANUAL_VOUCHER_PAYMENT_RECONCILIATION =
  'GET_MANUAL_VOUCHER_PAYMENT_RECONCILIATION';

export const CLEAR_MANUAL_VOUCHER_PAYMENT_RECONCILIATION =
  'CLEAR_MANUAL_VOUCHER_PAYMENT_RECONCILIATION';

export const FLAG_MANUAL_VOUCHER_PAYMENT_RECONCILIATION =
  'FLAG_MANUAL_VOUCHER_PAYMENT_RECONCILIATION';
